<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="群组ID">
                <el-input v-model="queryForm.groupId" placeholder="请填写群组ID" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="群组名称">
                <el-input v-model="queryForm.groupName" placeholder="请填写群组名称" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="管理员ID">
                <el-input v-model="queryForm.managerId" placeholder="请填写管理员ID" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getGroupList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group"></div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshGroupList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!--群组列表-->
            <el-table
                :data="groupList"
                width="100%"
                row-key="groupId"
                size="small"
                height="50%"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" type="selection" min-width="5%"> </el-table-column>
                <el-table-column align="center" label="群组ID" prop="groupId" min-width="15%"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="groupName" label="群组名称" min-width="15%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="群组头像" min-width="10%">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.headerImage"
                            :src="scope.row.headerImage"
                            style="width: 50px; height: 50px; border-radius: 4px;"
                            :preview-src-list="[scope.row.headerImage]"
                        ></el-image>
                        <span v-else>无头像</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="managerId" label="管理员ID" min-width="12%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="是否需要审核" min-width="10%">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.requireAudit === 1 ? 'success' : 'info'" size="small">
                            {{ scope.row.requireAudit === 1 ? '是' : '否' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="notice" label="群公告" min-width="15%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="创建时间" min-width="12%">
                    <template slot-scope="scpe">
                        {{ $moment(scpe.row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get } from '@/utils/request.js';
export default {
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            queryForm: {
                groupId: '',
                groupName: '',
                managerId: '',
                startTime: '',
                endTime: ''
            },
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            groupList: []
        };
    },
    created() {
        this.getGroupList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetGroupList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.groupList = [];
        },
        resetDialog() {
            this.queryForm = {
                groupId: '',
                groupName: '',
                managerId: '',
                startTime: '',
                endTime: ''
            };
            this.getGroupList();
        },
        refreshGroupList() {
            this.resetGroupList();
            this.getGroupList();
        },
        getGroupList() {
            this.loading = true;
            get(`/im/group/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.groupList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getGroupList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getGroupList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

